export default __webpack_public_path__ + "static/img-worries_people2_pc-0ccf2b9e4a845359e826ac4853c10c3f.svg";